
export default {
  name: 'BaseEditor',
  props: {
    existingContent: { type: Object, default: () => {} },
  },
  data() {
    return {
      editor: null,
      text: {},
    }
  },
  computed: {
    numberOfCharacters() {
      const paragraphs = this.text?.blocks?.filter(
        (block) => block.type === 'paragraph'
      )
      const paragraphsTextLength =
        paragraphs && paragraphs.length
          ? paragraphs.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const lists = this.text?.blocks?.filter((block) => block.type === 'list')
      const listsTextLength = this.listTextLength(lists)

      const headers = this.text?.blocks?.filter(
        (block) => block.type === 'header'
      )
      const headersTextLength =
        headers && headers.length
          ? headers.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const quotes = this.text?.blocks?.filter(
        (block) => block.type === 'quote'
      )
      const quotesTextLength =
        quotes && quotes.length
          ? quotes.reduce((acc, block) => {
              return acc + block.data.text.length + block.data.caption.length
            }, 0)
          : 0

      const tables = this.text?.blocks?.filter(
        (block) => block.type === 'table'
      )
      const tablesTextLength =
        tables && tables.length
          ? tables.reduce((acc, block) => {
              return (
                acc +
                block.data.content.reduce((acc, el) => {
                  return (
                    acc +
                    el.reduce((acc, el) => {
                      return acc + el.length
                    }, 0)
                  )
                }, 0)
              )
            }, 0)
          : 0

      const countTextCharacters =
        paragraphsTextLength +
        listsTextLength +
        headersTextLength +
        quotesTextLength +
        tablesTextLength
      return countTextCharacters
    },
  },
  async mounted() {
    this.text = this.existingContent
    const editorOptions = {
      id: 'megasreda-editor',
      data: this.text,
      onChange: this.onChange,
    }
    this.editor = this.$editor(editorOptions)
    await this.editor.isReady
  },
  methods: {
    async onChange() {
      try {
        await this.editor.save()
        const updatedData = await this.editor.save()
        this.text = updatedData
        this.$emit('contentChanged', updatedData)
      } catch (error) {
        console.log('Saving failed: ', error)
      }
    },
    listTextLength(lists) {
      const listsTextLength =
        lists && lists.length
          ? lists.reduce((acc, block) => {
              return acc + this.countListItemsText(block.data.items)
            }, 0)
          : 0
      return listsTextLength
    },
    countListItemsText(items) {
      if (items && items.length) {
        return items.reduce((acc, item) => {
          let count = acc + item.content.length
          if (item.items && item.items.length) {
            count = count + this.countListItemsText(item.items)
          }
          return count
        }, 0)
      }
    },
  },
}
